export const DotLoader = ({ color = "#000000", size = 20 }) => {
  return (
    <svg
      fill={color}
      width={size}
      height={size}
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Left dot */}
      <path d="M48,100a28,28,0,1,0,28,28A28.02769,28.02769,0,0,0,48,100Z">
        <animate
          attributeName="opacity"
          values="0;1;1;1"
          keyTimes="0;0.2;0.8;1"
          dur="1.2s"
          repeatCount="indefinite"
        />
        <animateTransform
          attributeName="transform"
          type="translate"
          values="0,10;0,0;0,0;0,0"
          keyTimes="0;0.2;0.8;1"
          dur="1.2s"
          repeatCount="indefinite"
        />
      </path>

      {/* Middle dot */}
      <path d="M128,100a28,28,0,1,0,28,28A28.02769,28.02769,0,0,0,128,100Z">
        <animate
          attributeName="opacity"
          values="0;0;1;1;1"
          keyTimes="0;0.2;0.4;0.8;1"
          dur="1.2s"
          repeatCount="indefinite"
        />
        <animateTransform
          attributeName="transform"
          type="translate"
          values="0,10;0,10;0,0;0,0;0,0"
          keyTimes="0;0.2;0.4;0.8;1"
          dur="1.2s"
          repeatCount="indefinite"
        />
      </path>

      {/* Right dot */}
      <path d="M208,100a28,28,0,1,0,28,28A28.02769,28.02769,0,0,0,208,100Z">
        <animate
          attributeName="opacity"
          values="0;0;0;1;1"
          keyTimes="0;0.4;0.6;0.8;1"
          dur="1.2s"
          repeatCount="indefinite"
        />
        <animateTransform
          attributeName="transform"
          type="translate"
          values="0,10;0,10;0,10;0,0;0,0"
          keyTimes="0;0.4;0.6;0.8;1"
          dur="1.2s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
};
